import Aos from "aos";
import "aos/dist/aos.css";
import {useEffect} from "react";

export default function Section( {animation, delay=50, className, style, children, ...props} ){

    useEffect(()=>{
        //https://github.com/michalsnik/aos
        if (animation){
            Aos.init({
                duration: 500,
                once: false, // whether animation should happen only once - while scrolling down
                mirror: false, // whether elements should animate out while scrolling past them
            });
        }
    },[animation]);

    return (
        <div className={className} data-aos={animation} data-aos-delay={delay} style={style} {...props}>{ children }</div>
    );
}
